export default "__VITE_ASSET__CB3SfQyy__"